import styled from '@emotion/styled';

const StackedImage = styled.figure`
  margin: 20px 20px;
  padding: 0;
  position: relative;
  img {
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    box-shadow: 1px 1px 2px rgb(0 0 0 / 25%);
  }
  img:first-of-type {
      -webkit-transform: translate(10px,-10px);
      transform: translate(10px,-10px);
  }
  img:last-of-type {
    position: relative;
  }
  img:nth-of-type(3) {
      -webkit-transform: translate(-10px,10px);
      transform: translate(-10px,10px);
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    margin: 10px 10px;
    width: 75px;
    img:first-of-type {
        -webkit-transform: translate(5px,-5px);
        transform: translate(5px,-5px);
    }
    img:last-of-type {
      position: relative;
    }
    img:nth-of-type(3) {
        -webkit-transform: translate(-5px,5px);
        transform: translate(-5px,5px);
    }
  }
}
`;
export default StackedImage;